import React, { Component } from 'react';
import {ChromePicker} from 'react-color'


class ColorPickerCell extends Component {
    constructor(props){
        super(props)
        this.state={
            show:false,
            background:"#ffffff"
        }
    }

    componentDidMount(){
        if(this.props.color !== this.state.background)
        {
            this.setState({
                background:this.props.color
            })
        }
    }

    handleChangeComplete = (color) => {
        this.setState({ background: color.hex });
        this.props.changeColor(color.hex)
    };

    areaOnClick = () => {
        this.setState({
            show:!this.state.show
        })
    }

    render(){
        let ColorArea = {
            width:"100%",
            height:"20px",
            backgroundColor:this.state.background,
            cursor:"pointer"
        }

        let ColorPickerArea = {
            position:"absolute",
            top:"0px",
            left:"230px",
            zIndex:500,
        }

        return(
            <div>
                <div style={ColorArea} onClick={this.areaOnClick}></div>
                {this.state.show?<div style={ColorPickerArea}><ChromePicker color={this.state.background} onChangeComplete={this.handleChangeComplete}/></div>:null}
            </div>
        )
    }
}

export default ColorPickerCell